import { styled, SxProps, Typography, useTheme } from "@mui/material";



interface TypographyPonMessageStyledProps {
    isvalid: string;
}
export const TypographyPonMessageStyled = styled(Typography, {
    label: "OrderOffer-TypographyPonMessage",
})<TypographyPonMessageStyledProps>(({ isvalid, theme }) => ({
    color: isvalid === 'true'   ? theme.palette.success.light : theme.palette.error.light,
    fontStyle: "italic",
    textTransform: "none",
}));

export const TypographyPonTitleStyled = styled(Typography, {
    label: "OrderOffer-TypographyPonTitleStyled",
})(({ theme }) => ({
    textTransform: "uppercase",
}));



/*



const useStyles = makeStyles({
    title: {
        transform: "translate(0, 0)",
    },

    titleLabel: {
        color: colors.black,
        textTransform: "uppercase",
        fontFamily: fonts.MEDIUM,
    },

    titleLabelOrder: {
        color: colors.sidelOrange,
        textTransform: "uppercase",
        fontFamily: fonts.MEDIUM,
    },

    root: {
        "& label": {
            textTransform: "uppercase",
            color: colors.sidelOrange,
            fontSize: "12px",
        },
        "& input": {
            color: colors.sidelGrey,
        },
        "& .MuiInput-input": {
            color: colors.sidelGrey,
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: colors.sidelGrey,
        },
        "& .MuiInput-underline:hover:before": {
            borderBottomColor: colors.sidelGrey,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: colors.sidelGrey,
        },
        marginTop: "10px",
        minHeight: "45px",
        maxWidth: "500px",
    },
    input: {
        "&::placeholder": {
            opacity: "0.6",
        },
    },
    
});
*/
